<template>
  <div v-if="isMounted" class="cookie-bar bg-white w-100 mx-100">
    <div
      v-if="isVisible && !showModal"
      class="cookie-bar-wrapper px-3 px-md-4 py-4"
    >
      <slot name="content"></slot>

      <div
        class="mt-lg-3 d-flex align-items-center justify-content-between flex-column flex-lg-row"
      >
        <slot name="links"></slot>
        <div
          class="d-flex cookie-buttons flex-column-reverse flex-sm-row mt-3 mt-lg-0"
        >
          <button
            class="btn cookie-bar-btn text-white text-center w-100"
            @click="acceptAllConsent"
          >
            {{ multiLanguage.CookieBarAcceptAll }}
          </button>
          <button
            class="btn bg-white text-dark cookie-bar-btn cookie-bar-reject-btn text-center w-100"
            @click="denyAllConsent"
          >
            {{ multiLanguage.CookieBarDenyAll }}
          </button>
          <button
            class="btn btn-primary bg-white cookie-bar-link"
            @click="openModal"
          >
            {{ multiLanguage.CookieBarPreferences }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="custom-modal-overlay">
      <div class="custom-modal-content bg-white">
        <div
          class="custom-modal-header d-flex align-items-center justify-content-between"
        >
          <h4>{{ multiLanguage.CookieBarTitle }}</h4>
          <button @click="closeModal">×</button>
        </div>
        <div class="custom-modal-body my-3">
          <p class="small">{{ multiLanguage.CookieBarDescription }}</p>
          <div class="d-flex align-items-center mt-1">
            <a
              class="d-block text-underline small"
              target="_blank"
              :href="privacyPolicyUrl"
            >
              {{ $translate("Ceres::Template.footerPrivacyPolicy") }}
            </a>
            <a
              class="d-block ml-3 text-underline small"
              target="_blank"
              :href="legalDisclosureUrl"
            >
              {{ $translate("Ceres::Template.footerLegalDisclosure") }}
            </a>
          </div>
          <div class="cookie-content-table my-2">
            <consent-list :consentGroups="consentGroups" />
          </div>
        </div>
        <div
          class="d-flex justify-content-start cookie-buttons flex-column-reverse flex-sm-row"
        >
          <button
            class="btn btn-primary cookie-bar-link text-center w-100"
            @click="acceptSelection"
          >
            {{ multiLanguage.CookieBarAcceptSelection }}
          </button>
          <button
            class="btn btn-primary cookie-bar-btn w-100"
            @click="acceptAllConsent"
          >
            {{ multiLanguage.CookieBarAcceptAll }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CookieBar",
  props: {
    multiLanguage: Object,
    consentGroups: Object,
  },
  components: {
    "consent-list": () => import("./ConsentList.vue"),
  },
  data() {
    return {
      isMounted: false,
      showModal: false,
      isCollapsed: false,
    };
  },
  computed: {
    isVisible() {
      return (
        !this.getCookie("consentGranted") &&
        (!this.$store.state.consents.hasResponse || !this.isCollapsed)
      );
    },
    privacyPolicyUrl() {
      return App.urls.privacyPolicy;
    },
    legalDisclosureUrl() {
      return App.urls.legalDisclosure;
    },
  },
  methods: {
    ...mapMutations(["acceptAll", "denyAll", "storeConsents"]),

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      return parts.length === 2 ? parts.pop().split(";").shift() : null;
    },
    denyAllConsent() {
      this.denyAll();
      this.showModal = false;
      this.isCollapsed = true;
    },
    acceptAllConsent() {
      this.acceptAll();
      this.showModal = false;
      this.isCollapsed = true;
    },
    openModal() {
      this.showModal = true;
      this.isCollapsed = true;
    },
    closeModal() {
      this.showModal = false;
      this.isCollapsed = false;
    },
    acceptSelection() {
      this.storeConsents();
      this.closeModal();
    },
  },
  mounted() {
    this.isMounted = true;
    this.$root.$on("openCookiePreferences", this.openModal);
  },
  beforeDestroy() {
    this.$root.$off("openCookiePreferences", this.openModal);
  },
};
</script>
